<template>
  <div>
    <div id="whatapp">
      <img src="@/assets/whatapp.jpg" />
    </div>
  </div>
</template>
<script>
export default {
  name: "WhatsApp",
  mounted() {
		var appMain = window.document.getElementById('appMain');
		appMain.style.paddingLeft = '0px'
	},
  
}
</script>

<style scoped>

#whatapp {
  background-color: #16C165;
  display: flex;
  justify-content: center;
  align-items: center;
}
#whatapp img{
  height: 100vh;
  object-fit: contain;
}
</style>